var ews = ews || {};
ews.components = ews.components || {};
ews.components.header = ews.components.header || {};
ews.components.header.search = ews.components.header.search || {};

ews.components.header.search.open = function() {
	var $searchNav = $('#Search_nav');
	$searchNav.addClass('search-active');
	$searchNav.find('.menuSearch').addClass('active');
	
	$('.overlay').removeClass('hide');
 	$('.overlay').addClass('overlay--menu');

	$('#siteSearch').focus();
	$("#siteSearch:text:visible:first").focus();
}

ews.components.header.search.close = function() {
	var $searchNav = $('#Search_nav');
	
	if (!$searchNav.hasClass('search-active')) return; //prevents clash with menu click

	$searchNav.removeClass('search-active');
	$searchNav.find('.menuSearch').removeClass('active');
	$('.overlay').addClass('hide');
	$('.overlay').removeClass('overlay--menu');
}

ews.components.header.search.toggle = function() {
	var $searchNav = $('#Search_nav');

	if ($searchNav.hasClass('search-active')) {
		ews.components.header.search.close();
	} else {
		ews.components.header.search.open();
	}

}
